<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    okText="确认"
    cancelText="取消"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="账号">
          <a-input v-decorator="['account', { rules: [{ required: true, message: '请输入账号' },{pattern:/^(?!_)\w+$/, message: '请使用英文、数字、和下划线'}] }]" />
        </a-form-item>
        <a-form-item label="真实姓名">
          <a-input v-decorator="['realName']" />
        </a-form-item>
        <a-form-item label="职位">
          <a-input v-decorator="['postion']" />
        </a-form-item>
        <a-form-item label="类型">
          <a-select v-decorator="['type', { initialValue: 1 }]">
            <a-select-option :value="1">管理员</a-select-option>
            <a-select-option :value="2">普通用户</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="所属企业">
          <a-select v-decorator="['enterpriseId']">
            <a-select-option v-for="d in enterpriseList" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
const fields = ['account', 'realName', 'type', 'postion', 'enterpriseId']
export default {
  name: 'UserForm',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    enterpriseList: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: '新增',
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    }
    return {
      form: this.$form.createForm(this),
    }
  },
  created() {
    console.log('custom modal created')

    // 防止表单未注册
    fields.forEach((v) => this.form.getFieldDecorator(v))

    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      console.log(this.model)
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted() {},
  methods: {},
}
</script>
